import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Heading } from '@pandiafi/design-system'
import { DetailRow } from '@pandiafi/components'

import { DefectNoticeEvent } from '../../../../../../common/validations/defectNotice'
import { Section } from '../../../../../components'
import { renderDate } from '../../../../../utils'
import { renderEventType } from '../../../utils'

export const DefectNoticeEvents: FC<{
  events?: DefectNoticeEvent[]
}> = ({ events }) => {
  const { t } = useTranslation('defectNotice')

  if (!events) {
    return null
  }

  return (
    <Section className="my-12">
      <Heading size="xs" element="h3" semibold>
        {t('texts.eventsTitle')}
      </Heading>
      <DetailRow>
        {events.map((evt) => (
          <DetailRow.Item
            key={evt.id}
            title={renderDate(evt.workFinishedAt || evt.createdAt)}
          >
            {renderEventType(evt)}
          </DetailRow.Item>
        ))}
      </DetailRow>
    </Section>
  )
}
